var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"flex-item_left"},[_c('patient-input')],1),_c('div',{staticClass:"flex-item_right"},[_c('patient-outcome')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }